import LiveClock from 'components/common/LiveClock'
import AccountForm from 'components/type/AddType'
import React from 'react'
import { useNavigate } from 'react-router-dom';
import FullPageLoader from 'components/common/FullPageLoader';

const CreateAccount = () => {
    const [loading, setLoading] = React.useState(true)
    const navigate = useNavigate();
    
    React.useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 500); 

        return () => clearTimeout(timer); 
    }, []);
    return (
        <div className='content'>
            {loading && <FullPageLoader />}
            <div className="row_main_head">
                <div className='d-flex align-items-center gap-2'>
                    <button className="main_heading back_button" onClick={() => navigate(-1)}>
                        <i className="fa-solid fa-arrow-left"></i> Back
                    </button>
                    <h2 className={`main_heading`}>Create Accounts</h2>
                </div>
                {/* <LiveClock /> */}
            </div>

            <AccountForm />
        </div>
    )
}

export default CreateAccount